import agent from "src/api/agent";




export const getSettings = (usr) => agent.requests.get(`/Admin/setting`);

export const updateSetting = (usr) => agent.requests.postMulti(`/Admin/updatesetting`, usr);

